import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules, Router } from '@angular/router';
import  { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { importProvidersFrom } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideStore } from '@ngrx/store';
import { sessionReducer } from '../src/utilities/session/session.reducer'; // o el reducer que corresponda
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { SessionEffects } from './utilities/session/session.effects';
import { provideEffects } from '@ngrx/effects';
import { IonicModule } from '@ionic/angular';
import { AuthHttpInterceptor } from './utilities/api/auth-http-interceptor.service';
import { spinnerInterceptor } from './loading.interceptor';
import { deviceInfoInterceptor } from './utilities/api/device-info.interceptor';
import { UtilsService } from './app/shared/utils.service';
import { L10N_CONFIG, L10nTranslationService } from 'angular-l10n';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { environment } from './environments/environment';

// Carga la API de Google Maps dinámicamente (igual que en PicTrack)
(function loadGoogleMaps() {
  if ((window as any).google?.maps || document.getElementById('gmaps-sdk')) return;

  const script = document.createElement('script');
  script.id = 'gmaps-sdk';
  script.type = 'text/javascript';
  script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.apiKeyGoogleMaps}&loading=async&libraries=drawing,marker`;
  script.async = true;
  script.defer = true;

  document.body.appendChild(script);
})();

// Listener global para deep links
App.addListener('appUrlOpen', (event) => {
  if (event.url.includes(`${environment.appScheme}://login`)) {
    const url = new URL(event.url);
    const token = url.searchParams.get('token');
    // Guardar token y continuar flujo
  }
});

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    importProvidersFrom(FormsModule, ReactiveFormsModule),
    provideStore({ session: sessionReducer }),
    provideHttpClient(),
    provideEffects([SessionEffects]),
    importProvidersFrom(
      IonicModule.forRoot({ mode: 'md' })  // Fuerza Material Design
    ),
    provideHttpClient(
      withInterceptors([spinnerInterceptor, deviceInfoInterceptor])
    ),
    UtilsService,
    
  ],
});
